import { App } from '@capacitor/app';
import { registerPlugin } from '@capacitor/core';
import { isNativeShell } from '../auth/authRedirect';

const LineMedicDoorAccess = registerPlugin('LineMedicDoorAccess');

export function nativeDoorAccessAvailable() {
  return isNativeShell();
}

export async function nativeDoorAccessClientInfo() {
  if (!nativeDoorAccessAvailable()) return { version: '', build: '' };
  const info = await App.getInfo();
  return {
    version: String(info?.version || '').trim(),
    build: String(info?.build || '').trim(),
  };
}

export async function unlockNativeDoor({ bluetoothName, guestKey }) {
  if (!nativeDoorAccessAvailable()) {
    throw new Error('Gear Room Access is only available in the Line Medic iPhone app.');
  }

  const name = String(bluetoothName || '').trim();
  const key = String(guestKey || '').trim();
  if (!name || !key) throw new Error('A valid Gear Room access credential is required.');

  const result = await LineMedicDoorAccess.unlock({ bluetoothName: name, guestKey: key });
  if (result?.success === false) throw new Error(result?.message || 'Unable to unlock the Gear Room lockbox.');
  return result || { success: true };
}
